module.exports = __webpack_public_path__ + "static/media/quote-icon-design.1a0f02b1.svg";